/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface AppControllerFindAppByLanguage$Params {
  appId: string;
  language: string;
}

export function appControllerFindAppByLanguage(http: HttpClient, rootUrl: string, params: AppControllerFindAppByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<App>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindAppByLanguage.PATH, 'get');
  if (params) {
    rb.path('appId', params.appId, {});
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<App>;
    })
  );
}

appControllerFindAppByLanguage.PATH = '/app/{appId}/language/{language}';
